import React from "react";
import { Button, Box, Typography } from "@mui/material";
import { STRINGS, VARIANTS, BUTTON_COLORS } from "../../common/constants/commonConstants.js";
import { CUSTOMER_STRINGS } from "../../common/constants/customerModule/customerConstants.js";
import DialogComponent from "../../common/components/DialogComponent.jsx";

const TextCustomerDialog = ({
    onText,
    open,
    selectedCustomer,
    onClose,
}) => {
    const handleSend = (e) => {
        // prevent any parent/form handlers from swallowing the click
        e?.preventDefault?.();
        e?.stopPropagation?.();
        console.log('Send clicked');
        onText?.(); // call the prop if provided
      };
    
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={selectedCustomer?.id ? CUSTOMER_STRINGS.TEXT_CUSTOMER : CUSTOMER_STRINGS.ADD_CUSTOMER}
                actions={
                    <Button
                        onClick={handleSend}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SEND}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    A sms test message will be initiated immediately. The message will constructed based on the customer's last dataset and related campaign.
                    </Typography>
                </Box>
            </DialogComponent>
        </>
    )
};

export default TextCustomerDialog;